import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import * as signalR from '@microsoft/signalr';
import { environment } from '../../../environments/environment';
import { LocalCacheService } from '../../services/localCache.service';

@Injectable({
  providedIn: 'root',
})
export class WebhookService {
  private signalRConnectionUrl = `${environment.WebhookUrl}/negotiate`;
  private hubConnection: any; // signalR.HubConnection;
  private _creditCardInfo = new BehaviorSubject<any>(null);

  public creditCardInfo$ = this._creditCardInfo.asObservable();
  public agentUniqueId: string = '';

  private _sip = new BehaviorSubject<any>(null);
  public sip$ = this._sip.asObservable();

  private _message = new BehaviorSubject<any>(null);
  public message$ = this._message.asObservable();

  constructor(
    private http: HttpClient,
    private localCacheService: LocalCacheService,
  ) {
    this.startSignalRConnection();
  }

  public startSignalRConnection() {
    this.http.post(this.signalRConnectionUrl, {}).subscribe(
      (response: any) => {
        this.hubConnection = new signalR.HubConnectionBuilder()
          .withUrl(response.url, {
            accessTokenFactory: () => response.accessToken,
          })
          .build();

        this.hubConnection.on('ReceiveCardInfo', (cardInfo: any) => {
          if (this.findByCallSid(cardInfo)) this._creditCardInfo.next(cardInfo);
        });

        this.hubConnection.on('ReceiveMessage', (message: any) => {
          if (this.findByCallSid(message)) this._message.next(message);
        });

        this.hubConnection
          .start()
          .then(() => {
            const connectionId = this.hubConnection.connectionId;
            console.log('Connection established. Connection ID:', connectionId);
          })
          .catch((err: any) => {
            console.error('Error while starting SignalR connection: ', err);
          });
      },
      (error: any) => {
        console.error('Error while making HTTP request: ', error);
      },
    );
  }
  public addToGroup(sid: string): Promise<any> {
    const url = `${environment.WebhookUrl}/${environment.ManageGroupUrl}`;
    return this.http
      .post(url, {
        connectionId: this.hubConnection.connectionId,
        sid,
        action: 'add',
      })
      .toPromise();
  }

  public removeFromGroup(sid: string): Promise<any> {
    const url = `${environment.WebhookUrl}/${environment.ManageGroupUrl}`;
    return this.http
      .post(url, {
        connectionId: this.hubConnection.connectionId,
        sid,
        action: 'remove',
      })
      .toPromise();
  }
  async closeHubConnection() {
    if (this.hubConnection) {
      await this.hubConnection.StopAsync();

      // Optionally dispose of the connection
      this.hubConnection.Dispose();
    }
  }

  findByCallSid(data: string) {
    let findSid = false;
    var callInfo: any = this.localCacheService.getSessionStorage('callinfo');
    if (callInfo) {
      const match = data.match(new RegExp(`CallSid=([^&]+)`));
      if (match && match.length > 0) {
        //callInfo = JSON.parse(callInfo);
        findSid = match[0].includes(callInfo?.sip);
      }
    }
    console.log('Sid matched: ' + findSid);
    return findSid;
  }
}
